<template>
	<div class="page">
		<div class="columnTitle">
			<div class="columnTitleL">
				用户信息
				<i class="el-icon-view" slot="reference" style="font-size: 20px;vertical-align: middle;color:#577BFF;" @click="compCustomRecord_state=true"></i>
			</div>
			<div class="columnTitleR">
				<el-button type="warning" @click="$router.back()">返回</el-button>
			</div>
		</div>
		<div class="baseMsgLine">
			<div class="baseMsgLineR">
				<div class="baseMsgLineRItem">
					<div class="l">昵称:</div>
					<div class="v">
						<img v-if="userDetail.vip_grades.grades==1" style="width:35px;padding-right: 6px;vertical-align: text-bottom;" src="../../../assets/img/member/vip1.png"/>
						<img v-if="userDetail.vip_grades.grades==2" style="width:35px;padding-right: 6px;vertical-align: text-bottom;" src="../../../assets/img/member/vip2.png"/>
						<img v-if="userDetail.vip_grades.grades==3" style="width:35px;padding-right: 6px;vertical-align: text-bottom;" src="../../../assets/img/member/vip3.png"/>
						<img v-if="userDetail.vip_grades.grades==4" style="width:35px;padding-right: 6px;vertical-align: text-bottom;" src="../../../assets/img/member/vip4.png"/>
						<img v-if="userDetail.vip_grades.grades==5" style="width:35px;padding-right: 6px;vertical-align: text-bottom;" src="../../../assets/img/member/vip5.png"/>
						{{userDetail.basic_info.nick_name}}
					</div>
				</div>
				<div class="baseMsgLineRItem">
					<div class="l">电话:</div>
					<div class="v">{{userDetail.basic_info.user_mobile}}</div>
				</div>
				<div class="baseMsgLineRItem">
					<div class="l">性别:</div>
					<div class="v">{{userDetail.basic_info.sex}}</div>
				</div>
				<div class="baseMsgLineRItem">
					<div class="l">最后活跃时间:</div>
					<div class="v">{{userDetail.user_event?$public.FTime(userDetail.user_event.app_last_time):"- -"}}</div>
				</div>
				<div class="baseMsgLineRItem">
					<div class="l">描述:</div>
					<div class="v">{{userDetail.basic_info.user_desc}}</div>
				</div>
				<div class="baseMsgLineRItem">
					<div class="l">邮箱:</div>
					<div class="v">{{userDetail.basic_info.user_email}}</div>
				</div>
				<div class="baseMsgLineRItem">
					<div class="l">生日:</div>
					<div class="v">{{$public.FTime(userDetail.basic_info.birthday,'YYYY-MM-DD')}}</div>
				</div>
				<div class="baseMsgLineRItem">
					<div class="l">地址:</div>
					<div class="v">{{userDetail.basic_info.home_address}}</div>
				</div>
				<div class="baseMsgLineRItem">
					<div class="l">注册时间:</div>
					<div class="v">
						{{$public.FTime(userDetail.operation_info.create.create_time,'YYYY-MM-DD')}}
						{{userDetail.operation_info.create.create_from?'('+userDetail.operation_info.create.create_from+')':''}}
					</div>
				</div>
				<div class="baseMsgLineRItem">
					<div class="l">会员备注:</div>
					<div class="v">
						<el-tooltip class="item" effect="dark" :content="userDetail.basic_info.remark" placement="top-start">
							<div style="width:200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{userDetail.basic_info.remark}}</div>
						</el-tooltip>
					</div>
				</div>
				<div class="baseMsgLineRItem">
					<div class="l">紧急联系方式:</div>
					<div class="v">{{userDetail.basic_info.urgent_user}} {{userDetail.basic_info.urgent_user_mobile}}</div>
				</div>
			</div>
		</div>
		<div class="columnTitle" style="margin-top:16px;">
			<div class="columnTitleL">用户资产</div>
			<div class="columnTitleR">
				
			</div>
		</div>
		<div class="navBox">
			<div style="display: flex;">
				<div class="navItem" :class="curNavIndex===0?'active':''" @click="changeCurNavIndex(0)">会员卡</div>
				<div class="navItem" :class="curNavIndex===1?'active':''" @click="changeCurNavIndex(1)">宠物</div>
				<div class="navItem" :class="curNavIndex===4?'active':''" @click="changeCurNavIndex(4)">积分</div>
				<div class="navItem" :class="curNavIndex===5?'active':''" @click="changeCurNavIndex(5)">成长值</div>
				<div class="navItem" :class="curNavIndex===2?'active':''" @click="changeCurNavIndex(2)">洗美卡</div>
				<div class="navItem" :class="curNavIndex===3?'active':''" @click="changeCurNavIndex(3)">优惠券</div>
				<!-- <div class="navItem" :class="curNavIndex===6?'active':''" @click="changeCurNavIndex(6)">退换货(30)</div> -->
			</div>
			<div style="display: flex;justify-content: flex-end;">
				<!-- <div class="navItem1" :class="curNavIndex===7?'active':''" @click="changeCurNavIndex(7)">
					<div class="la">购物车</div>
					<div class="va"></div>
				</div>
				<div class="navItem1" :class="curNavIndex===8?'active':''" @click="changeCurNavIndex(8)">
					<div class="la">收藏数</div>
					<div class="va"></div>
				</div>
				<div class="navItem1" :class="curNavIndex===9?'active':''" @click="changeCurNavIndex(9)">
					<div class="la">关注数</div>
					<div class="va"></div>
				</div>
				<div class="navItem1" :class="curNavIndex===10?'active':''" @click="changeCurNavIndex(10)">
					<div class="la">粉丝数</div>
					<div class="va"></div>
				</div> -->
			</div>
		</div>
		<div class="contentBox" v-if="userDetail._id">
			<!-- 会员卡 -->
			<compYueItem :userDetail="userDetail" v-if="curNavIndex===0"></compYueItem>
			<!-- 宠物 -->
			<compPetsItem v-if="curNavIndex===1"></compPetsItem>
			<!-- 卡 -->
			<compCardItem :userDetail="userDetail" v-if="curNavIndex===2"></compCardItem>
			<!-- 优惠券 -->
			<compCouponItem v-if="curNavIndex===3"></compCouponItem>
			<!-- 积分 -->
			<compJifenItem :userDetail="userDetail" v-if="curNavIndex===4"></compJifenItem>
			<!-- 充值 -->
			<compGradeItem :userDetail="userDetail" v-if="curNavIndex===5"></compGradeItem>
			<!-- 退换 -->
			<compOrderReturnItem v-if="curNavIndex===6"></compOrderReturnItem>
			<!-- 购物车 -->
			<compCartItem v-if="curNavIndex===7"></compCartItem>
			<!-- 收藏 -->
			<compCollectItem v-if="curNavIndex===8"></compCollectItem>
			<!-- 关注 -->
			<compFollowItem v-if="curNavIndex===9"></compFollowItem>
			<!-- 粉丝 -->
			<compFansItem v-if="curNavIndex===10"></compFansItem>
		</div>
		
		<!-- 自定义记录 -->
		<div v-if="compCustomRecord_state">
			<compCustomRecord :linkId="userDetail._id" :type="1" @submit="compCustomRecord_state=false"></compCustomRecord>
		</div>
	</div>
</template>

<script>
	import compYueItem from "./seeNavItem/compYueItem.vue"
	import compPetsItem from "./seeNavItem/compPetsItem.vue"
	import compCartItem from "./seeNavItem/compCartItem.vue"
	import compCollectItem from "./seeNavItem/compCollectItem.vue"
	import compFollowItem from "./seeNavItem/compFollowItem.vue"
	import compFansItem from "./seeNavItem/compFansItem.vue"
	import compCardItem from "./seeNavItem/compCardItem.vue"
	import compCouponItem from "./seeNavItem/compCouponItem.vue"
	import compJifenItem from "./seeNavItem/compJifenItem.vue"
	import compGradeItem from "./seeNavItem/compGradeItem.vue"
	import compOrderReturnItem from "./seeNavItem/compOrderReturnItem.vue"
	import compCustomRecord from "@/components/compCustomRecord.vue"
	
	export default {
		components:{compYueItem,compPetsItem,compCartItem,compCollectItem,compFollowItem,compFansItem,compCardItem,compCouponItem,compJifenItem,compGradeItem,compOrderReturnItem,compCustomRecord},
		data() {
			return {
				
				curNavIndex:0,
				
				userDetail:{
					auth_info:{},
					basic_info:{},
					card_info:{},
					operation_info:{
						create:{}
					},
					vip_grades:{},
				},
				// 自定义记录
				compCustomRecord_state:false,
			}
		},
		computed:{
			
		},
		created(){
			
		},
		mounted(){
			this.getUserDetail()
		},
		methods:{
			changeCurNavIndex(i){
				this.curNavIndex=i;
			},
			getUserDetail() {
				let params = {
					"id": this.$route.query.id,
				}
				this.$http.get(process.env.VUE_APP_member+'/api/middleware/Member/Single', params).then(res => {
					if (res.code == 0) {
						this.userDetail = res.data;
					}
				})
			},
			
		},
	}
</script>

<style lang="scss" scoped>
	.page{
		padding:16px 16px;height: 100%;box-sizing: border-box;position: relative;overflow: auto;
		.columnTitle{
			display: flex;justify-content: space-between;
			.columnTitleL{
				font-size: 18px;color:$color333;line-height: 40px;font-weight: bold;
				&::before{
					display: inline-block;content:'';width:4px;height: 20px;background: linear-gradient(315deg, #338AFF 0%, #3F69FF 100%);border-radius: 4px;margin-right: 12px;vertical-align: sub;
				}
			}
			.columnTitleR{
				
			}
		}
		.baseMsgLine{
			margin-top:16px;display: flex;
			.baseMsgLineL{
				width:272px;height: 188px;border-radius: 16px;background-color: #fff;margin-right: 16px;flex-shrink: 0;
				.pictureBox{
					text-align: center;padding-top:20px;
					.pic1{
						width:70px;height: 70px;border-radius: 50%;
					}
				}
				.memberName{
					font-size: 14px;color:$color333;font-weight: bold;text-align: center;padding-top:10px;
				}
				.memberDesc{
					font-size: 12px;color:$color666;text-align: center;padding:10px 0;
				}
				.memberXing{
					
				}
				.memberTime{
					font-size: 12px;color:$colorB5;text-align: center;
				}
			}
			.baseMsgLineR{
				width:100%;height: 188px;background-color: #fff;border-radius: 16px;display: flex;flex-wrap: wrap;padding:16px 1px;box-sizing: border-box;
				.baseMsgLineRItem{
					width:25%;display: flex;line-height: 52px;font-size: 14px;color:$color333;
					.l{
						width:100px;text-align: right;margin-right: 10px;flex-wrap: wrap;flex-shrink: 0;
					}
					.v{
						width:100%;
					}
				}
			}
		}
		.navBox{
			width:100%;height: 68px;border-radius: 12px;background-color: #F0EDF7;margin-top:6px;display: flex;justify-content: space-between;padding:8px;box-sizing: border-box;
			.navItem{
				height: 52px;border-radius: 8px;padding:0 22px;font-size: 14px;color:$color333;line-height: 52px;cursor: pointer;
				&.active{
					background: linear-gradient(135deg, #5685FF 0%, #3569FF 100%);color:#fff;
				}
			}
			.navItem1{
				height: 52px;border-radius: 8px;padding:0 22px;font-size: 14px;color:$color333;cursor: pointer;text-align: center;
				&.active{
					background: linear-gradient(135deg, #5685FF 0%, #3569FF 100%);color:#fff;
					.la{
						color:#fff;
					}
					.va{
						color:#fff;
					}
				}
				.la{
					font-size: 14px;color:$color666;padding-top:10px;
				}
				.va{
					font-size: 16px;color:$color333;padding-top:6px;
				}
			}
		}
		.contentBox{
			height: calc(100% - 84px);
		}
	}
</style>
